<template>
  <validation-observer ref="calendarForm">
    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <b-col cols="12">
          <validation-provider
            v-slot="{ errors }"
            name="Nombre del calendario"
            rules="required"
          >
            <b-form-group
              label="Nombre del calendario"
              label-for="calendar-name"
            >
              <b-form-input
                id="calendar-name"
                v-model="form.name"
                placeholder="Ej: Calendario 2025"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12">
          <validation-provider
              v-slot="{ errors }"
              name="Año"
              rules="required"
          >
            <b-form-group
                label="Año"
                label-for="calendar-year"
            >
              <b-form-input
                  id="calendar-year"
                  v-model="form.year"
                  type="number"
                  :min="currentYear"
                  :max="currentYear + 10"
                  placeholder="Ej: 2025"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12">
          <b-form-group
              :label="'Comunidad autónoma'"
              label-for="calendar-autonomous_community"
          >
            <BaseSelect
                v-model="form.autonomous_community"
                :searchable="true"
                :clearable="true"
                :multiple="false"
                :resource="'/calendars/autonomous-communities'"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <b-form-checkbox
              v-model="form.sync_public_holidays"
              switch
            >
              Sincronización vacaciones automáticamente
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="text-right mt-2">
        <b-button
          variant="outline-primary"
          class="mr-1"
          @click="$emit('cancel')"
        >
          Cancelar
        </b-button>
        <b-button
          type="submit"
          variant="primary"
        >
          Crear calendario
        </b-button>
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapActions } from 'vuex'
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BButton,
  BRow,
  BCol,
} from 'bootstrap-vue'
import BaseSelect from '@/components/ui/select/BaseSelect.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    BRow,
    BCol,
    BaseSelect,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      form: {
        name: '',
        year: new Date().getFullYear(),
        sync_public_holidays: true,
        autonomous_community: '',
      },
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
  },
  methods: {
    ...mapActions({
      createCalendar: 'calendar/create',
      listCalendars: 'calendar/list',
    }),
    async handleSubmit() {
      const valid = await this.$refs.calendarForm.validate()
      if (!valid) return

      await this.createCalendar({
        ...this.form,
        client_id: this.clientId,
      })

      await this.listCalendars({ client_id: this.clientId })

      this.$emit('success')
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
